import gql from 'graphql-tag';

export const DUPLICATE_PURCHASE_ORDER = gql`
	mutation duplicatePurchaseOrderMutation($id: ID!) {
		duplicatePurchaseOrder(id: $id) {
			id
			identifier
		}
	}
`;
